import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

import SecureLS from "secure-ls";
var ls = new SecureLS({ isCompression: false });

export default createStore({
  state: {
    login: false,
    user: null,
    saltKey: import.meta.env.VITE_SALT_KEY,
    schema: [], 
 images: [], 
 ai: [],
    exams: [],
    examsUser: [],
    examQuestions: [],
    userExamQuestions: [],
    questions: [],
    users: [],
    contacts: [],
    tasks: [],
    mermaid: [],
    solved: [],
    solvedTimes: [],
    userExamsSolveds: [],
    sinifs: [],
    dersler: [],
    units: [],
  },
  mutations: {
    setLogin(state, login) {
      state.login = login;
    },
    setUser(state, user) {
      console.log("user :>> ", user);
      state.user = user;
    },
    logoutUser(state) {
      state.user = null;
    },
    addContacts(state, contacts) {
      state.contacts = [...contacts];
    },
    addQuestions(state, questions) {
      state.questions = [...questions];
    },
    addExams(state, exams) {
      state.exams = [...exams];
    },
    addExamsUser(state, examsUser) {
      state.examsUser = [...examsUser];
    },
    addExamQuestions(state, examQuestions) {
      state.examQuestions = [...examQuestions];
    },
    addUserExamQuestions(state, userExamQuestions) {
      state.userExamQuestions = [...userExamQuestions];
    },
    addAi(state, ai) { 
 state.ai = [...ai]; 
}, 
 addImages(state, images) { 
 state.images = [...images]; 
}, 
 addSchema(state, schema) {
      state.schema = [...schema];
    },
    addUsers(state, users) {
      state.users = [...users];
    },
    addTasks(state, tasks) {
      state.tasks = [...tasks];
    },
    addMermaid(state, mermaid) {
      state.mermaid = [...mermaid];
    },
    addSinif(state, sinifs) {
      state.sinifs = [...sinifs];
    },
    addDers(state, dersler) {
      state.dersler = [...dersler];
    },
    addUnits(state, units) {
      state.units = [...units];
    },
    addMermaidItem(state, item) {
      state.mermaid.push(item);
    },
    updateMermaidItem(state, updatedItem) {
      const index = state.mermaid.findIndex(
        (item) => item.id === updatedItem.id
      );
      if (index !== -1) {
        state.mermaid.splice(index, 1, updatedItem);
      }
    },
    deleteMermaidItem(state, id) {
      state.mermaid = state.mermaid.filter((item) => item.id !== id);
    },
    addSolved(state, solved) {
      state.solved = [...solved];
    },  
    addSolvedTime(state, solvedTime) {
      state.solvedTimes = [...solvedTime];
    },
    addUserExamsSolveds(state, userExamsSolveds) {
      state.userExamsSolveds = [...userExamsSolveds];
    },
  },
  getters: {
    _getLogin: (state) => state.login,
    _isAuthenticated: (state) => state.user !== null,
    _getCurrentUser(state) {
      const user = state.user;

      delete user?.password;
      return user;
    },
    _currentUserId: (state) => state?.user?.id,
    _getCurrentRole: (state) => parseInt(state?.user?.role),
    _saltKey: (state) => state.saltKey,
    _getContacts: (state) => state?.contacts,
    _getQuestions: (state) => state?.questions,
    _getExamQuestions: (state) => state?.examQuestions,
    _getUserExamQuestions: (state) => state?.userExamQuestions,
    _getExams: (state) => state?.exams,
    _getExamsUser: (state) => state?.examsUser,
    _getAi: (state) => state?.ai, 
 _getImages: (state) => state?.images, 
 _getSchema: (state) => state?.schema,
    _getUsers: (state) => state?.users,
    _getTasks: (state) => state?.tasks,
    _getMermaid: (state) => state?.mermaid,
    _getSolved: (state) => state?.solved,
    _getSolvedTimes: (state) => state?.solvedTimes,
    _getUserExamsSolveds: (state) => state?.userExamsSolveds,
    _getSinif: (state) => state?.sinifs,
    _getDers: (state) => state?.dersler,
    _getUnits: (state) => state?.units,
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
});
